import React, { Component } from 'react';
import OtpInput from 'react-otp-input';

export default class Otp extends Component {

    handleChange = (otp) => {
        const { handleFieldChange, name, inputType } = this.props
        let tempval;

        switch (inputType) {
            case 'number':
            tempval = otp ? otp.replace(/[^0-9]/g, "") : null;
            break;
        case 'alpha':
            tempval = otp ? otp.replace(/[^a-zA-Z]/g, "") : null;
            break;
        case 'alphanumeric':
            tempval = otp ? otp.replace(/[^a-zA-Z0-9]/g, "") : null;
            break;
        case 'specialCharacters':
            tempval = otp ? otp.replace(/[a-zA-Z0-9]/g, "") : null;
            break;
        default:
            tempval = otp;
        }
        let events = { target: { value: tempval, name: name, checked: false } }
        handleFieldChange(events);
    }

    render() {
        const { value } = this.props
        return (
            <div>
                <OtpInput
                    value={value}
                    onChange={this.handleChange}
                    numInputs={6}
                    separator={<span>-</span>}
                    inputStyle={{ width: '3em', height: '3em' }}
                    //inputType="number" 
                />
            </div>
        );
    }
}